<script>
import { find } from 'lodash-es';
</script>

<script setup>
import { OhVueIcon } from 'oh-vue-icons';
import { Button } from 'flowbite-vue';
import { storeToRefs } from 'pinia';

import TranslationValue from '@/components/layouts/TranslationValue.ce.vue';

import { useChooserFormStore } from '@/store/forms/chooser';
import { useApiResponsesStore } from '@/store/responses';

const apiResponseStore = useApiResponsesStore();
const { occupationResponses } = storeToRefs(apiResponseStore);

const formStore = useChooserFormStore();
const { formData } = storeToRefs(formStore);

const levels = {
    one: {
        set: (identifier) => {
            formStore.$patch((state) => {
                state.formData.occupation.levelOne = find(
                    occupationResponses.value.levelOneOccupations,
                    { id: identifier }
                );
            });
        },
        clear: () => {
            formStore.$patch((state) => {
                state.formData.occupation.levelOne = null;
                state.formData.occupation.levelTwo = null;
            });
        },
    },
    two: {
        set: (identifier) => {
            formStore.$patch((state) => {
                state.formData.occupation.levelTwo = find(
                    occupationResponses.value.levelTwoOccupations,
                    { id: identifier }
                );
            });
        },
        clear: () => {
            formStore.$patch((state) => {
                state.formData.occupation.levelTwo = null;
            });
        },
    },
};
</script>

<template>
    <template v-if="occupationResponses.levelOneOccupations">
        <h2 class="my-4 text-lg">
            <TranslationValue id="page1_dropdown_platform" />
        </h2>
        <div v-if="!formData.occupation.levelOne">
            <div
                class="inline-block mb-4 bg-gray-100 text-gray-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded"
            >
                <TranslationValue id="page1_expla_multiple_platforms" />
            </div>
        </div>

        <div class="inline-flex gap-2 flex-wrap items-center">
            <template v-if="formData.occupation.levelOne">
                <Button color="default" @click="levels.one.clear()">
                    {{ formData.occupation.levelOne.name }}
                    <template #suffix>
                        <OhVueIcon name="hi-x" />
                    </template>
                </Button>
            </template>
            <template v-else>
                <Button
                    v-for="(
                        item, index
                    ) in occupationResponses.levelOneOccupations"
                    :key="index"
                    color="default"
                    :outline="true"
                    @click="levels.one.set(item.id)"
                >
                    {{ item.name }}
                </Button>
            </template>
        </div>

        <div
            v-if="
                formData.occupation.levelOne &&
                occupationResponses.levelTwoOccupations
            "
        >
            <h2 class="my-4 text-lg">
              <TranslationValue id="page1_dropdown_job" />
            </h2>
            <div>
                <div
                    class="inline-block mb-4 bg-gray-100 text-gray-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded"
                >
                    <TranslationValue id="page1_expla_multiple_jobs" />
                </div>
            </div>
            <div class="inline-flex align-left gap-2 flex-wrap">

                <template v-if="formData.occupation.levelTwo">
                    <Button color="default" @click="levels.two.clear()">
                        {{ formData.occupation.levelTwo.name }}
                        <template #suffix>
                        <OhVueIcon name="hi-x" />
                        </template>
                    </Button>
                </template>
                <template v-else>
                    <Button
                        v-for="(
                            item, index
                        ) in occupationResponses.levelTwoOccupations"
                        :key="index"
                        color="default"
                        :outline="true"
                        @click="levels.two.set(item.id)"
                    >
                      {{ item.name }}
                    </Button>
                </template>
            </div>
        </div>
    </template>
</template>

<style scoped></style>
